import { Map, User } from './../classes.js';
import { api } from './../function/api.js';
import * as icon from './../vars/icons.js';
import DOMPurify from 'dompurify'; 

export class cSearch {
	constructor() {
		this.s = null;
		this.lat = null;
		this.lng = null;
		this.zoom = null;
		this.active = false;
		this.triggered_move = false;
		this.bounds = {};
		this.search_results = Array();
		this.search_markers = L.layerGroup();
		this.temp_rs_markers = Array();
		
		let trip_focus = null;
		let marker_focus = null;
		
		/*** SEARCH HANDLER ***/
		$('body').on('submit', '.form--search', async function(e){
			e.preventDefault();
			
			let focus_results = {};
			let query = DOMPurify.sanitize($(this).find('[name="s"]').val());
			let key_result = {};
			
			//get results for this query
			focus_results = await fetch(`https://nominatim.openstreetmap.org/search?q=${query}&format=json&addressdetails=1`, {
				method: 'GET',
				headers: {
						'Accept': 'application/json'
				}
			}).then((e) => {
				return e.json();
			});
			
			//console.log(focus_results);
			//determine if there is a "best fit" for our system
			if(focus_results.length > 0){
				let lead_score = 0;
				
				focus_results.forEach(function(rs, index) {
					let score = 0;
					
					if(rs.address.country_code == 'us'){
						score++;
					}
					if(typeof(rs.address.city) != 'undefined'){
						if(rs.address.city.includes(query)){
							score++;
						}
					}
					if(typeof(rs.address.state) != 'undefined'){
						if(rs.address.state.includes(query)){
							score++;
						}
					}
					if(typeof(rs.address.postcode) != 'undefined'){
						if(rs.address.postcode.includes(query)){
							score++;
						}
					}
					if(typeof(rs.address.county) != 'undefined'){
						if(rs.address.county.includes(query)){
							score++;
						}
					}
					if(typeof(rs.address.country) != 'undefined'){
						if(rs.address.country.includes(query)){
							score++;
						}
					}
					if(rs.display_name.includes(query)){
						score++;
					}
					
					
					if(score > lead_score || lead_score == 0){
						lead_score = score;
						key_result = rs;
					}
				})
			}else{
				//if we don't have a result, we should set it to the user's preferred pin.
				key_result = {}
			}
			
			//console.log(key_result);
			window.location.href = `/explore?s=${encodeURIComponent(query)}&lat=${key_result.lat}&lng=${key_result.lon}&zoom=8`;
			return false;
			
		});
		
		/*** HIGHLIGHT HANDLER ***/
		$('body').on({
	
			mouseenter: function (e) {
				if(e.data.obj.active){
					trip_focus = $(this).attr('data-slug');
					marker_focus = e.data.obj.search_results[trip_focus];
					
					marker_focus.openPopup();
				}
			},
			mouseleave: function (e) {
				if(e.data.obj.active){
					marker_focus.closePopup();
					
					trip_focus = null;
					marker_focus = null;
				}
			}
		}, ".card--trip", {obj: this});
	}
	
	set() {
		this.params = new URLSearchParams(window.location.search);
		this.active = true;
		
		// Get specific variable
		this.s = this.params.get('s');
		this.lat = this.params.get('lat') ? this.params.get('lat') : User.info.focus_lat ? User.info.focus_lat : 39.8282;
		this.lng = this.params.get('lng') ? this.params.get('lng') : User.info.focus_lng ? User.info.focus_lng : -98.5796;
		this.zoom = this.params.get('zoom') ? this.params.get('zoom') : User.info.focus_zoom ? User.info.focus_zoom : 4;
		
		this.triggered_move = true;
		Map.setView([this.lat, this.lng], this.zoom);
	}
	
	async search(bounds) {
		//prepare the data we need for our search
		let data = new FormData();
		data.append('ne_lat', bounds._northEast.lat);
		data.append('ne_lng', bounds._northEast.lng);
		data.append('sw_lat', bounds._southWest.lat);
		data.append('sw_lng', bounds._southWest.lng);
		
		//run the query against our database
		let response = await api('/explore/search', data);
		
		if(response.error){
			
		}else{
			//reset results
			$('#explore_results').html('');
			
			if(response.data.length > 0){
				
				this.render_results(response.data)
				
			}else{
				$('#explore_results').append(this.no_results());
			}
		}
	}
	
	no_results(){
		let p = `
			<div class="search__no_results">
				<h3>No Results Found</h3>
				<p>There are currently no matching trips within the given map boundries. Be the first to create and share an adventure in this area or keep exploring to find a trip nearby.!</p>
				
				<p>
					<a class="btn btn--primary" href="/t/create">Start a Trip</a>
				</p>
				
				<p>Becoming a creator is easy and you are recieve a portion of each sale of your trips. Get started by learning about the overall process of using the Jaxbend Trip planning system <a href="/how-to-use-jaxbend">here</a>.
			</div>
		`;
		
		return p;
	}
	
	render_results(trips){
		let header = `<h3>Exploring Trips</h3>`;
		if(this.s != null){
			header = `<h3>Trips near ${this.s}</h3>`;
		}
		//clear existing results
		this.search_markers.clearLayers();
		this.temp_rs_markers = Array();
		this.search_results = {};
		
		//build the display
		$('#explore_results').append(header);
		
		for (const [key, trip] of Object.entries(trips)) {
			//append the card first, so we can update it with marker information
			$('#explore_results').append(trip.card);
			
			//register marker
			let mark = L.marker([trip.attributes.focus_lat, trip.attributes.focus_lng], {icon: icon.search_icon}).bindPopup(`
				<div>
					<h5>${trip.attributes.name}</h5>
				</div>
			`);
			
			this.search_results[trip.attributes.slug] = mark;
			this.temp_rs_markers.push(mark);
			
		};
		
		this.search_markers = L.layerGroup(this.temp_rs_markers);
		this.search_markers.addTo(Map);
		
		console.log(this.search_results);
		
	}
}